<template>
  <div>
    <Banner :classType="5" />
    <Menu />
    <div class="pageTitle wow animate__slideInUp">
      <h2>社会责任</h2>
      <p>SOCIAL RESPONSIBILITY</p>
    </div>
    <div class="wrap responseBox wow animate__slideInUp">
      <NewsList actionTxt="资料下载" :newsList="newsList" down="down" />
      
    </div>
    <div class="pageBox"><Pagination @pageChange="getData" :PagingInfo="PagingInfo" /></div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Banner from "@/views/components/Banner";
import NewsList from "@/views/components/NewsList";
import { WOW } from "wowjs";
import Pagination from "@/views/components/Pagenation";


export default {
  data() {
    return { newsList: [], PagingInfo: {} };
  },
  components: {
    NewsList,
    Menu,
    Banner,
    Pagination
  },
  methods: {
    getData(page, type) {
      this.$api
        .fileList({
          Type: 3,
          CurrentPage: page,
          ItemsPerPage:8
        })
        .then((res) => {
          const { FileInfos, PagingInfo } = res.Value;
          this.newsList = FileInfos;
          this.PagingInfo = PagingInfo;
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
  },
  mounted() {
    this.getData(1, "first");
  },
};
</script>

<style lang="scss">
.responseBox {
  padding: 50px 0;
}
</style>